export default {
  english: 'English',
  arabic: 'Arabic',
  login: 'Login',
  cart: 'Cart',
  sidebar: {
    dashboard: 'dashboard',
    products: 'products',
    orders: 'orders',
    offers: 'offers',
    withdraw: 'withdraw',
    reviews: 'reviews',
    categories: 'categories',
    collection: 'collection',
    processing: 'processing',
    settings: 'settings',
    collections: 'collections',
    financialOperations: 'Financial Operations',
    withdrawalRequests: 'Withdrawal Requests',
    doctors: 'Doctors'
  }
}
